module.exports = __webpack_public_path__ + "static/media/left-dark.85debe21.svg";